import { render, staticRenderFns } from "./HerramientaCierrePF.vue?vue&type=template&id=7e130f1d&scoped=true"
import script from "./HerramientaCierrePF.vue?vue&type=script&lang=js"
export * from "./HerramientaCierrePF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e130f1d",
  null
  
)

export default component.exports